export const PayCardStatus = {
  Active: "active",
  Suspended: "suspended",
  Terminated: "terminated",
  UnActivated: "unactivated",
};
export type PayCardStatus = (typeof PayCardStatus)[keyof typeof PayCardStatus];
